import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { connectFirestoreEmulator, getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API,
  authDomain: 'skola-mezi-stromy.firebaseapp.com',
  projectId: 'skola-mezi-stromy',
  storageBucket: 'skola-mezi-stromy.appspot.com',
  messagingSenderId: '699052983510',
  appId: '1:699052983510:web:c021658383440848ed7577',
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);

export const auth = getAuth(app);

if (process.env.NODE_ENV === 'development') {
  connectFirestoreEmulator(db, 'localhost', 8080);
}
